import { createContext, useContext } from "react";
import { Handler } from "../../types/handler";

export type SeekBarState = {
  width: number;
  offset: number;
  isPointerDown: boolean;
  isPointerInside: boolean;
  activeHandler?: Handler;
  hoverHandler?: Handler;
  lastPointerPosition?: number;
};

export const SeekBarContext = createContext<SeekBarState | undefined>(
  undefined
);

export const useSeekBar = () => {
  const state = useContext(SeekBarContext);

  if (state === undefined) {
    throw new Error(
      "useSeekBar must be used within a SeekBarProvider provider."
    );
  }

  return state;
};
